<template>
  <div class="summary-form">
    <v-row
      class="mb-8"
      justify="center"
    >
      <v-col cols="12">
        <div
          class="block-title"
          style="text-align: center"
        >
          ПРОДАЖИ\ПЛАТЕЖИ
        </div>
      </v-col>
    </v-row>
    <v-row class="justify-end">
      <v-col
        cols="12"
        sm="2"
      >
        <v-btn
          text
          :plain="true"
          :ripple="false"
          @click="onSetPeriod(0)"
        >
          ВЧЕРА
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="2"
      >
        <v-btn
          text
          :plain="true"
          :ripple="false"
          @click="onSetPeriod(1)"
        >
          СЕГОДНЯ
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="2"
      >
        <v-btn
          text
          :plain="true"
          :ripple="false"
          @click="onSetPeriod(2)"
        >
          НЕДЕЛЯ
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="2"
      >
        <v-btn
          text
          :plain="true"
          :ripple="false"
          @click="onSetPeriod(3)"
        >
          МЕСЯЦ
        </v-btn>
      </v-col>
      <!--      <v-col cols="10">-->
      <!--        <v-tabs-->
      <!--          v-model="tab"-->
      <!--          :slider-size="1"-->
      <!--          background-color="transparent"-->
      <!--          color="#4C60C7"-->
      <!--          height="30px"-->
      <!--          right-->
      <!--          slider-color="#4C60C7"-->
      <!--        >-->
      <!--          <v-tab>СЕГОДНЯ</v-tab>-->
      <!--          <v-tab>НЕДЕЛЯ</v-tab>-->
      <!--          <v-tab>МЕСЯЦ</v-tab>-->
      <!--        </v-tabs>-->
      <!--      </v-col>-->
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="justify-end"
      >
        <v-btn
          text
          :plain="true"
          :ripple="false"
          @click="dialogToFromVisible=true"
        >
          Задать период
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="onAllPayments"
          :value="payments_values.all"
          color="#FD9A13"
          icon="mdi-counter"
          small-value=""
          sub-icon=""
          sub-icon-color=""
          sub-text="Посмотреть"
          sub-text-color="#8E8D8D"
          title="Количество"
          value-color="#FD9A13"
          value-size="36px"
          value-weight="400"
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="onFaultPayments"
          :value="payments_values.error"
          color="#E91E63"
          icon="mdi-alert-circle-outline"
          small-value=""
          sub-icon=""
          sub-text="Посмотреть"
          sub-text-color="#8E8D8D"
          title="Ошибочных"
          value-color="#E91E63"
          value-size="36px"
          value-weight="400"
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="testSubTextFunction"
          :value="payments_values.sum"
          color="#4CAF50"
          icon="mdi-cash-100"
          small-value=""
          sub-icon=""
          sub-text=""
          sub-text-color="#8E8D8D"
          title="Сумма"
          value-color="#4CAF50"
          value-size="24px"
          value-weight="400"
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="testSubTextFunction"
          :value="payments_values.avg"
          color="#00CAE3"
          icon="mdi-receipt"
          small-value=""
          sub-icon=""
          sub-text=""
          sub-text-color="#8E8D8D"
          title="Средний чек"
          value-color="#00CAE3"
          value-size="24px"
          value-weight="400"
        />
      </v-col>
    </v-row>
    <v-row
      class="mx-2"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
      >
        <div
          class="block-title my-3"
          style="text-align: center"
        >
          ИЗБРАННЫЕ ТОЧКИ
        </div>
        <v-card>
          <v-card-text>
            <dashboard-table-favorite-points
              :period="tab"
              :date-to="dateTo"
              :date-from="dateFrom"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <div
          class="block-title my-3"
          style="text-align: center"
        >
          СТАТИСТИКА ПО ТОВАРАМ
        </div>
        <v-card>
          <v-card-text>
            <dashboard-table-product-statistics
              :period="tab"
              :date-to="dateTo"
              :date-from="dateFrom"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <div
          class="block-title"
          style="text-align: center"
        >
          СПОСОБЫ ОПЛАТЫ
        </div>
      </v-col>
      <v-col cols="12">
        <payment-methods-doughnut
          :part-id="`paymentMethods`"
          :payment-methods="paymentMethods"
          type="vacancy"
        />
      </v-col>
    </v-row>
    <v-row
      class="mb-8"
      justify="center"
    >
      <v-col cols="12">
        <div
          class="block-title"
          style="text-align: center"
        >
          ТОЧКИ ОБСЛУЖИВАНИЯ
        </div>
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="testSubTextFunction"
          :value="(dashboard.points.all || 0).toString()"
          color="#00CAE3"
          icon="mdi-counter"
          small-value=""
          sub-icon=""
          sub-icon-color=""
          sub-text=""
          sub-text-color="#8E8D8D"
          title="Количество"
          value-color="#00CAE3"
          value-size="36px"
          value-weight="400"
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="testSubTextFunction"
          :value="(dashboard.points.online || 0).toString()"
          color="#4CAF50"
          icon="mdi-lan-connect"
          small-value=""
          sub-icon=""
          sub-text=""
          sub-text-color="#8E8D8D"
          title="На связи"
          value-color="#4CAF50"
          value-size="36px"
          value-weight="400"
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="onOfflineDevices"
          :value="(dashboard.points.offline || 0).toString()"
          color="#E91E63"
          icon="mdi-lan-disconnect"
          small-value=""
          sub-icon=""
          sub-text="Посмотреть"
          sub-text-color="#8E8D8D"
          title="Нет связи"
          value-color="#E91E63"
          value-size="36px"
          value-weight="400"
        />
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="6"
        xl="3"
      >
        <material-stats-card-custom
          :sub-text-click="testSubTextFunction"
          :value="(dashboard.points.error || 0).toString()"
          color="#FD9A13"
          icon="mdi-alert-circle-outline"
          small-value=""
          sub-icon=""
          sub-text="Посмотреть"
          sub-text-color="#8E8D8D"
          title="Ошибки"
          value-color="#FD9A13"
          value-size="36px"
          value-weight="400"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <div
          class="block-title"
          style="text-align: center"
        >
          КАРТА
        </div>
      </v-col>
      <v-col cols="12">
        <yandex-map />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <item-list-pagination
          :dialog-visible="itemList.dialogVisible"
          :headers="itemListHeader"
          :item-list="itemListItems"
          :loading="loading"
          :path-edit-only="itemPathEditOnly"
          :path-view-only="itemPathViewOnly"
          :title="itemList.title"
          :total="itemListCount"
          @close="itemList.dialogVisible=false"
          @nextPage="func"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <dialog-to-from-date
          v-if="dialogToFromVisible"
          @cancel="dialogToFromVisible=false"
          @changeDate="onChangeDate($event)"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
// import $ from 'jquery'
import { JustpayPointService } from "@/views/loyalty/shared/services/justpay-point-service"
import { JustpayCommonService } from "@/views/loyalty/shared/services/justpay-common-service"
import { JustpayPaymentService } from "@/views/loyalty/shared/services/justpay-payment-service"

import { ymapMarker } from "vue-yandex-maps"
import ItemListPagination from "@/views/loyalty/shared/components/item-list/ItemListPagination.vue"
import DialogToFromDate from "@/views/loyalty/shared/components/dialog-date-picker/DialogToFromDate.vue"
import { format } from "date-fns-tz"
import { ru } from "date-fns/locale"
import { MonitoringService } from "@/views/monitoring/shared/services/monitoring-service"
// import ItemList from "@/views/loyalty/shared/components/item-list/ItemList.vue"
export default {
    components: {
      DialogToFromDate,
        // ItemList,
        ItemListPagination,
        ymapMarker,
        MaterialStatsCardCustom: () => import('../../../components/base/MaterialStatsCardCustom'),
        PaymentMethodsDoughnut: () => import('../../../components/common/PaymentMethodsDoughnut.vue'),
        YandexMap: () => import('../../../components/common/YandexMap.vue'),
        DashboardTableFavoritePoints: () => import('../../../components/common/DashboardTableFavoritePoints.vue'),
        DashboardTableProductStatistics: () => import('../../../components/common/DashboardTableProductStatistics.vue'),
    },
    data: () => ({
        tab: 1,
        dashboard: {
            payments: {
                all: 0,
                avg: 0,
                error: 0,
                sum: 0,
                types: {
                    card: 25,
                    cash: 25,
                    loyalty: 25,
                    sbp: 25
                }
            },
            points: {
                all: 0,
                error: 0,
                offline: 0,
                online: 0
            }
        },
        itemList: {
            dialogVisible: false,
            items: [],
            title: null,

        },
        itemListCount: 0,
        itemListItems: [],
        itemListHeader: [],
      itemPathEditOnly: '',
      itemPathViewOnly: '',
        func: 0,
        justpayCommonService: null,
        justpayPaymentService: null,
        justpayPointService: null,
      monitoringService: null,
        loading: false,
        map: {
            coords: [54.735147, 55.958727],
            settings: {
                apiKey: 'df228d50-f05d-46b7-b2a7-afccf3a31cb3',
                lang: 'ru_RU',
                coordorder: 'latlong',
                version: '2.1',

            },
            controls: ['geolocationControl', 'rulerControl', 'typeSelector', 'zoomControl'],
            points: [],
            clusterOptions: {
                points: {
                    clusterDisableClickZoom: true,
                    clusterOpenBalloonOnClick: true,
                },
            },
        },
        /* , paymentMethods: [
          {
            value: 50,
            color: '#35B982',
            label: 'Наличные',
          },
          {
            value: 100,
            color: '#00D8FF',
            label: 'Банковская карта',
          },
          {
            value: 20,
            color: '#E11C01',
            label: 'СБП',
          },
          {
            value: 10,
            color: '#E7664D',
            label: 'Лояльность',
          }
        ] */
      allPoints: 0,
      allOfflinePoints: [],
      allOfflinePayments: 0,
      allOfflinePointsDateUpdated: [],
      dialogToFromVisible: false,
      dateFrom: new Date().toISOString(),
      dateTo: new Date().toISOString()
    }),
    computed: {
        max_date () {
            return moment().format('YYYY-MM-DD')
        },
        paymentMethods () {
            const result = [
                {
                    value: this.dashboard.payments.types.cash || 0,
                    color: '#35B982',
                    label: 'Наличные',
                },
                {
                    value: this.dashboard.payments.types.card || 0,
                    color: '#00D8FF',
                    label: 'Банковская карта',
                },
                {
                    value: this.dashboard.payments.types.sbp || 0,
                    color: '#E11C01',
                    label: 'СБП',
                },
                {
                    value: this.dashboard.payments.types.loyalty || 0,
                    color: '#E7664D',
                    label: 'Лояльность',
                }
            ]
            return result
        },
        filter_date () {
            let date = {
                from: null,
                to: null
            }
            switch (this.tab) {
                case 0: // Вчера
                    date = {
                        from: moment().add(-1, 'days').format('YYYY-MM-DD'),
                        to: moment().add(-1, 'days').format('YYYY-MM-DD')
                    }
                    break
                case 1: // Сегодня
                    date = {
                        from: moment().format('YYYY-MM-DD'),
                        to: moment().format('YYYY-MM-DD')
                    }
                    break
                case 2: // Неделя
                    date = {
                        from: moment().add(-1, 'week').format('YYYY-MM-DD'),
                        to: moment().format('YYYY-MM-DD')
                    }
                    break
                case 3: // Месяц
                    date = {
                        from: moment().add(-1, 'month').format('YYYY-MM-DD'),
                        to: moment().format('YYYY-MM-DD')
                    }
                    break
              case 4:
                date = { from: this.dateFrom, to: this.dateTo }
                    break
            }
            return date
        },
        payments_values () {
            const result = {
                all: (this.dashboard.payments.all || 0).toString(),
                error: (this.dashboard.payments.error || 0).toString(),
                sum: this.thousandSeparator(Number(this.dashboard.payments.sum || 0).toFixed(2) || 0).toString(),
                avg: (Number(this.dashboard.payments.avg) || 0).toFixed(2).toString()
            }
            return result
        }
    },
    watch: {
        filter_date: {
            handler () {
                this.loadDashboardData()
            },
            deep: true,
        }
    },
    beforeMount () {
        this.justpayCommonService = new JustpayCommonService()
        this.justpayPaymentService = new JustpayPaymentService()
        this.justpayPointService = new JustpayPointService()
      this.monitoringService = new MonitoringService()
    },

    mounted: function () {
      console.log('this.filter_date.from', this.filter_date.from)
      console.log('this.filter_date.to', this.filter_date.to)
        this.loadDashboardData()
    },
    methods: {
        testSubTextFunction () {
            console.log('testSubTextFunction')
        },
        async loadDashboardData () {
          // this.dashboard.points.all = await this.justpayPointService.getPlacePoints(clientId)
          const result = await this.axios.post('/api/common/dashboard', { date: this.filter_date })
          this.dashboard = result.data
          this.allOfflinePoints = await this.justpayCommonService.getOfflinePoints(this.$store.state.client.id, { page: 1, itemsPerPage: -1 })
          // console.log('allOfflinePoints', this.allOfflinePoints)
          const allOfflinePointsId = this.allOfflinePoints.pointAdb.map(m => m.pointId)
          // console.log('allOfflinePointsId', allOfflinePointsId)
          this.allOfflinePointsDateUpdated = await this.monitoringService.getOfflinePoints({ pointsId: allOfflinePointsId })
          // console.log('allOfflinePointsDateUpdated', this.allOfflinePointsDateUpdated)
          this.allOfflinePayments = await this.getOfflinePoints(this.allOfflinePoints, {
            page: 1,
            itemsPerPage: this.allOfflinePoints.pointAdb.length,
          })
        },
        thousandSeparator (str) {
            const parts = (str + '').split('.')
            const main = parts[0]
            const len = main.length
            let output = ''
            let i = len - 1
            while (i >= 0) {
                output = main.charAt(i) + output
                if ((len - i) % 3 === 0 && i > 0) {
                    output = ' ' + output
                }
                --i
            }
            if (parts.length > 1) {
                output += '.' + parts[1]
            }
            return output
        },
        async onAllPayments (tableOptions) {
            this.func = this.onAllPayments
            this.itemList.dialogVisible = true
            this.loading = true
            // console.log('this.filter_date', this.filter_date)
            const payments = await this.justpayPaymentService.getPayments(this.$store.state.client.id, this.filter_date, tableOptions)
            // console.log('payments', payments)
            this.itemList.title = 'Количество'
            this.itemListHeader = [
              { text: "Просмотр", value: "view_only", sortable: false, show: true },
                { text: "Точки", value: "point_name" },
                { text: "Товары", value: "items_name" },
              { text: "Тип оплаты", value: "type" },
                { text: "Сумма", value: "sum" },
                { text: "Дата", value: 'created' }]
            this.itemListItems = payments.payments
            this.itemListCount = payments.count
          this.itemPathViewOnly = 'payment/view'
            this.loading = false
        },
      onChangeDate (event) {
        this.dialogToFromVisible = false
        console.log('dateFrom->', event.dateFrom)
        this.dateFrom = event.dateFrom
        console.log('dateTo->', event.dateTo)
        this.dateTo = event.dateTo
        this.tab = 4
        // this.filter_date = {to: event.dateTo, from: event.dateFrom}
        // this.filter_date.from = event.dateFrom
      },
      // onChangeDateFrom () {
      //   console.log('dateFrom->', this.dateFrom)
      // },
      // onChangeDateTo () {
      //   console.log('dateTo->', this.dateTo)
      // },
        async onFaultPayments (tableOptions) {
            this.func = this.onFaultPayments
            this.itemList.dialogVisible = true
            this.loading = true
            console.log('tableOptions', tableOptions)
            console.log('this.filter_date', this.filter_date)
            const faultPayment = await this.justpayPaymentService.getFaultPayments(this.$store.state.client.id, this.filter_date, tableOptions)
          if (faultPayment.count === 0) {
            this.loading = false
            return
          }
            console.log('payments', faultPayment.payments)
            this.itemList.title = 'Ошибочные'
            this.itemListHeader = [
              { text: "Просмотр", value: "view_only", sortable: false, show: true },
                { text: "Точки", value: "point_name" },
                { text: "Товары", value: "items_name" },
              { text: "Тип оплаты", value: "type" },
                { text: "Сумма", value: "sum" },
                { text: "Последний статус", value: 'state' },
              { text: "Описание статуса", value: 'state_comment' },
              { text: "Дата", value: 'date' },
            ]
            this.itemListItems = faultPayment.payments
            this.itemListCount = faultPayment.count
          this.itemPathViewOnly = 'payment/view'
            this.loading = false
        },
      async getOfflinePoints (allPoints, tableOptions) {
        console.log('getOfflinePoints allPoints', allPoints)
        console.log('getOfflinePoints tableOptions', tableOptions)
        if (tableOptions === undefined) {
          tableOptions = { page: 1, itemsPerPage: 10 }
        }
        const offlinePoints = []
          allPoints.pointAdb.forEach(s => {
            const point = this.allOfflinePointsDateUpdated.offlinePoints.find(f => s.pointId === f.pointId)
            console.log('point', point)
            if (point !== undefined) {
              offlinePoints.push({ pointName: s.pointName, address: s.address, updated: format(new Date(point.updated), 'dd MMMM yyyy HH:mm', { locale: ru }) })
            } else {
              offlinePoints.push({ pointName: s.pointName, address: s.address, updated: '' })
            }
          })
        return offlinePoints.slice((tableOptions.page - 1) * tableOptions.itemsPerPage, (tableOptions.page - 1) * tableOptions.itemsPerPage + tableOptions.itemsPerPage)
      },
        async onOfflineDevices (tableOptions) {
            this.func = this.onOfflineDevices
            this.itemList.dialogVisible = true
            this.loading = true
           const offlinePoints = await this.getOfflinePoints(this.allOfflinePoints, tableOptions)
            this.itemList.title = 'Нет связи'
            this.itemListHeader = [
              { text: "Действие", value: "edit", sortable: false, show: true },
                { text: "Точки", value: "pointName" }, { text: "Адрес", value: "address" }, { text: 'Дата последнего отклика', value: 'updated' }]

          // console.log('onOfflineDevices offlinePoints', offlinePoints)
            this.itemListItems = offlinePoints
            this.itemListCount = this.dashboard.points.offline // OfflinePointsDateUpdated.count // all offline points
            this.loading = false
          this.itemPathViewOnly = 'point/view'
          this.itemPathEditOnly = 'point/change'
        },
      onSetPeriod (period) {
          this.tab = period
      },
      onViewConfiguration (item) {
        const routeData = this.$router.resolve({ path: 'view', query: { id: item.id } })
        window.open(routeData.href, '_blank')
      }
    }
}
</script>
<style lang="scss">
.summary-form {
  .block-title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: #989898;
  }
}
</style>
